/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Button } from 'components/_new/Button';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'contexts/authContext';
import { linkedAccountApi } from 'api';
import { usePanel } from 'contexts/panelContext';
import { useGlobal } from 'contexts/globalContext';
import { useScope } from 'contexts/scopeContext';
import { MessageBox } from 'components/_new/MessageBox';
import { Segment } from './Segment';
import { LinkedAccountIntegrate } from './LinkedAccountIntegrate';
import { LinkedAccountList } from './LinkedAccountList';

export const LinkedAccountSection = () => {
	const { t } = useTranslation();
	const { toastRef } = useGlobal();
	const { currentProgramMembership } = usePanel();
	const { currentProgram } = useScope();
	const { currentUser } = useAuth();

	const { data: linkedAccounts } = useQuery(
		['GET_LINKED_ACCOUNTS', { id: Number(currentUser?.id) }],
		() => linkedAccountApi.getLinkedAccounts(),
		{ enabled: false, initialData: [] }
	);

	const [manageMode, setManageMode] = useState<boolean>(false);

	const handleRemove = () => {
		setManageMode(false);
		toastRef?.current?.show({
			severity: 'success',
			life: 3000,
			summary: t(`misc.success`),
			detail: 'Konto zostało odłączone pomyślnie',
		});
	};

	return (
		<Segment
			title={t('linkedAccount.myAccount.title')}
			right={
				currentProgram?.calendarApiIntegration && linkedAccounts.length > 0
					? () =>
							!manageMode ? (
								<Button
									label={t('linkedAccount.myAccount.actions.manage')}
									onClick={() => {
										setManageMode(true);
									}}
									icon="pencil"
									variant="primary-outlined"
									variantSize="sm"
								/>
							) : (
								<Button
									label={t('actions.cancel')}
									onClick={() => {
										setManageMode(false);
									}}
									variant="primary-outlined"
									variantSize="sm"
								/>
							)
					: undefined
			}
			full
		>
			{!currentProgram?.calendarApiIntegration && (
				<MessageBox message={t('linkedAccount.session.linkedAccountDsabledByProgramSetting')} />
			)}

			{currentProgram?.calendarApiIntegration && (
				<>
					<LinkedAccountList
						integrateParams={{ programId: currentProgram?.id, membershipId: currentProgramMembership?.id }}
						manageMode={manageMode}
						onRemove={handleRemove}
						displayAdditionalInformation
					/>

					{!manageMode && (
						<LinkedAccountIntegrate
							programId={currentProgram?.id}
							membershipId={currentProgramMembership?.id}
						/>
					)}
				</>
			)}
		</Segment>
	);
};
